import Player from 'youtube-player'
import getVideoId from 'get-video-id'

import EventBus from '@/js/util/eventBus'
import playerProps from '@/js/util/props/playerProps'

// Both PlayerYoutube and PlayerVimeo work outisde of
// the loader without any aditional configuration

export default {
  props: {
    // shared props with
    // PlayerLoader, PlayerVimeo
    ...playerProps,
  },

  data: () => ({
    toggle: false,
    player: undefined,
  }),

  computed: {
    determineModalUsage() {
      if (!this.useModal) {
        return false
      }

      return window.innerWidth > 1024
    },
  },

  created() {
    // if you are using this with the modal you
    // will have to pass in the prop useModal
    EventBus.$on(
      `toggle:${this.useModal ? 'modal' : 'video'}`,
      this.maybeToggle
    )
  },

  mounted() {
    const { id } = getVideoId(this.url)
    let options = {
      videoId: id,
      modestbranding: 1,
      rel: 0,
    }
    if (this.background == true) {
      this.toggle = true
      options = {
        height: '100%',
        width: '100%',
        videoId: id,
        modestbranding: 1,
        rel: 0,
        playerVars: {
          playlist: id,
          autoplay: 1, // Auto-play the video on load
          controls: 0, // Show pause/play buttons in player
          showinfo: 1, // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          loop: 1, // Run the video in a loop
          fs: 0, // Hide the full screen button
          cc_load_policy: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 1, // Hide video controls when playing
          playsinline: 1, //forbid fullscreen on ios
        },
      }
    }

    this.player = new Player(this.$el, Object.assign(options, this.options))
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been rendered
      if (this.background == true) {
        this.player.playVideo()
        this.player.mute()
      }
    })

    this.player.on('stateChange', this.handleStateChange)
    // EventBus.$on('modal:focus', this.handleFocus)
  },

  methods: {
    maybeToggle(playerId) {
      // if the VideoButton and the VideoPlayer
      // dont have same the id prop do nothing
      if (playerId !== this.playerId) {
        return
      }

      this.toggle = !this.toggle
      console.log(window.innerWidth)

      this.player[this.toggle ? 'playVideo' : 'pauseVideo']()
    },
    handleStateChange({ data }) {
      const stateNames = { 2: 'paused' }[data]
      if (!stateNames) {
        return
      }

      this.player.pauseVideo()
    },
    handleFocus(modalId) {
      if (modalId === this.playerId) {
        this.player.getIframe().then(iframe => {
          iframe.focus()
        })
      }
    },
  },

  render: createElement => createElement('div'),
}
